module.exports = __webpack_public_path__ + "static/media/totp_icon.9e019322.svg";